import { createContext, useContext } from "react";

export const StaffingDepartmentsContext = createContext(null);

export const useStaffingDepartmentsContext = () =>
  useContext(StaffingDepartmentsContext);
